import type {
  Allergy,
  MedicalCondition,
  Patient,
  PatientAllergy,
  PatientMedicalCondition,
} from '@dataTypes/PatientInfo.types'

export const getPatientAllergyTitles = (
  patient?:
    | Pick<Patient, 'patient_allergies' | 'allergy_ids'>
    | null
    | undefined,
  allergyCatalog?: Allergy[],
): string[] => {
  if (!patient) return []

  if (patient.patient_allergies?.length) {
    return patient.patient_allergies
      .map(
        (row: PatientAllergy) =>
          row.allergy?.title?.trim() ||
          allergyCatalog?.find((a) => a.allergy_id === row.allergy_id)?.title ||
          '',
      )
      .filter(Boolean)
  }

  if (patient.allergy_ids?.length && allergyCatalog?.length) {
    return patient.allergy_ids
      .map(
        (id) =>
          allergyCatalog.find((a) => a.allergy_id === id)?.title?.trim() || '',
      )
      .filter(Boolean)
  }

  return []
}

export const getPatientMedicalConditionTitles = (
  patient?:
    | Pick<Patient, 'patient_medical_conditions' | 'medical_condition_ids'>
    | null
    | undefined,
  medicalConditionCatalog?: MedicalCondition[],
): string[] => {
  if (!patient) return []

  if (patient.patient_medical_conditions?.length) {
    return patient.patient_medical_conditions
      .map(
        (row: PatientMedicalCondition) =>
          row.medical_condition?.title?.trim() ||
          medicalConditionCatalog?.find(
            (c) => c.medical_condition_id === row.medical_condition_id,
          )?.title ||
          '',
      )
      .filter(Boolean)
  }

  if (
    patient.medical_condition_ids?.length &&
    medicalConditionCatalog?.length
  ) {
    return patient.medical_condition_ids
      .map(
        (id) =>
          medicalConditionCatalog
            .find((c) => c.medical_condition_id === id)
            ?.title?.trim() || '',
      )
      .filter(Boolean)
  }

  return []
}

export const formatTitleList = (titles: string[]): string =>
  titles.length ? titles.join(', ') : 'N/A'

export const extractAllergyIdsFromPatient = (
  patient?: Patient | null,
): string[] => {
  if (!patient) return []
  if (patient.allergy_ids?.length) return patient.allergy_ids
  return (
    patient.patient_allergies?.map((row) => row.allergy_id).filter(Boolean) ??
    []
  )
}

export const extractMedicalConditionIdsFromPatient = (
  patient?: Patient | null,
): string[] => {
  if (!patient) return []
  if (patient.medical_condition_ids?.length)
    return patient.medical_condition_ids
  return (
    patient.patient_medical_conditions
      ?.map((row) => row.medical_condition_id)
      .filter(Boolean) ?? []
  )
}
